module.exports = __webpack_public_path__ + "static/media/logo.bf4e3cdf.png";